import {
  Modal,
  ModalHeader,
  ModalBody,
  Box,
  Text,
  AccordionItem,
  Accordion,
  AccordionItemHeader,
  AccordionItemBody,
  UserIcon,
  Link,
  ExternalLinkIcon,
} from '@razorpay/blade/components';
import { DuplicateChecksModalDetails } from '../types';
import { routePaths } from 'components/Routes/data';
import { statesOfIndiaCodeMap } from '../data';

export interface DuplicateChecksModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  details: DuplicateChecksModalDetails | null | undefined;
}

const DuplicateChecksModal = ({
  isOpen,
  onDismiss,
  details,
}: DuplicateChecksModalProps) => {
  const onReview = (employee: DuplicateChecksModalDetails[number]) => {
    window.open(`${routePaths.employeeDetails.root}${employee.user_id}`, '_blank');
  };

  if (!details) return null;
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} accessibilityLabel="Duplicate Checks Modal">
      <ModalHeader
        title="Duplicate Check"
        subtitle="The following employee(s) have a matching details based on the details you entered:"
      />

      <ModalBody>
        <Box display="flex" flexDirection="column" gap="spacing.3">
          <Accordion size="medium" variant="filled">
            {details.map((employee) => (
              <AccordionItem>
                <AccordionItemHeader>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box display="flex" alignItems="center" gap="spacing.2">
                      <UserIcon size="small" />
                      <Text
                        variant="body"
                        size="small"
                        weight="semibold"
                        color="surface.text.gray.normal">
                        {employee.user_name}
                      </Text>
                    </Box>
                    <Link
                      marginRight="spacing.4"
                      icon={ExternalLinkIcon}
                      iconPosition="right"
                      variant="button"
                      size="small"
                      onClick={() => onReview(employee)}>
                      Review
                    </Link>
                  </Box>
                </AccordionItemHeader>

                <AccordionItemBody>
                    <Box
                      display="flex"
                      flexDirection="column"
                      gap="spacing.2"
                      marginLeft="spacing.5"
                      >
                      <Text size="small" color="surface.text.gray.muted">
                        Role: {employee.role ?? '--'}
                      </Text>
                      <Text size="small" color="surface.text.gray.muted">
                        Department: {employee.department ?? '--'}
                      </Text>
                      <Text size="small" color="surface.text.gray.muted">
                        Location: {employee.location ? statesOfIndiaCodeMap[employee.location] : '--'}
                      </Text>
                    </Box>
                </AccordionItemBody>
              </AccordionItem>
            ))}
          </Accordion>
        </Box>
      </ModalBody>
    </Modal>
  );
};

export default DuplicateChecksModal;
